export const PersonaEntity = {
    id: null,
    docIdentidad: '',
    escalafon: '',
    nombre: '',
    apellido: '',
    fecNacimiento: null,
    direccion: '', 
    email: '',
    nroTelefono: '',
    estado: true 
};